enum TypePeriode {
	DEMANDE = 0,
	PROPOSE = 1,
	VOTE = 2,
	CA_CFU = 3,
}

export default TypePeriode;
